import { useRef, useEffect } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { MonitorQueueAPI } from '../../constants/API';
import {
  MonitorsUnitType,
  ReceivedSoundArrType
} from '../../components/Main/QueuePanel/QueuePanel';
import { transformReceivedSounds } from '../../utils/QueuePage/transformReceivedSounds';
import { getMonitorBranchCode, getMonitorToken, queueScreenHeaders } from '../../constants/HeadersAPI';

export const useQueueItems = (
  setReceivedSoundArr: (soundsArr: ReceivedSoundArrType) => void,
  isSoundPlaying: boolean
) => {
  const isTokenAvailable = !!getMonitorToken();
  const isSoundPlayingRef = useRef(isSoundPlaying);
  useEffect(() => {
    isSoundPlayingRef.current = isSoundPlaying;
  }, [isSoundPlaying]);

  const {
    data: queueItemsResp,
    isLoading: isLoadingQueueItems,
    isSuccess: isQueueItemsRecieved
  } = useQuery(
    ['windows', getMonitorToken(), getMonitorBranchCode()],
    () => axios.get<MonitorsUnitType>(MonitorQueueAPI.getQueueItems, queueScreenHeaders()),
    {
      select: ({ data }) => data,
      onSuccess: (data) => {
        if (!isSoundPlayingRef.current) {
          setReceivedSoundArr(transformReceivedSounds(data.items));
        }
      },
      enabled: isTokenAvailable,
      refetchInterval: 4000
    }
  );

  return { queueItemsResp, isLoadingQueueItems, isQueueItemsRecieved };
};
